export const isReporter = (auth) => auth.user?.authorities?.includes('REPORTER')
export const isPartner = (auth) => auth.user?.authorities?.includes('PARTNER')
export const isOperator = (auth) => auth.user?.authorities?.includes('OPERATOR')

